import { AfterContentInit, Component, inject, OnInit, viewChild } from "@angular/core";
import { Router, RouterOutlet } from '@angular/router';
import { takeUntil, tap } from "rxjs/operators";

import { Environment } from "../environments/environment";
import { AppFeatureEnum, BreadcrumbService2, Market, OrgSelectionService, UnsubscribeOnDestroy } from "shared";
import { Observable } from "rxjs";
import { AsyncPipe } from "@angular/common";


@Component({
    selector: "my-app",
    templateUrl: "./home.component.html",
    styleUrls: ['./home.component.scss'],
    standalone: true,
    imports: [
        RouterOutlet,
        AsyncPipe
    ]
})
export class HomeComponent extends UnsubscribeOnDestroy implements AfterContentInit {
    private orgSelectionService = inject(OrgSelectionService);
    private router = inject(Router);
    private breadcrumbService = inject(BreadcrumbService2);
    
    bwpUrl: string = Environment.bwpUrl;
    bqaUrl: string = Environment.bqaUrl;
    enableBWP: boolean;
    enableBQA: boolean;
    enablePurchaseOrders: boolean;
    enableRecordables: boolean;
    enableSchedules: boolean;
    enableService: boolean;
    enableReport: boolean = true;
    selectedMarket$: Observable<Market>;
    selectedMarket: Market;
    serviceUrl: string = Environment.serviceUrl;

    reportingUrl: string = Environment.reportingUrl;

    readonly child = viewChild(RouterOutlet);

    constructor() { super(); }

    ngAfterContentInit(): void {
        setTimeout(() => {
            this.breadcrumbService.setCrumbs({ label: "Welcome to the Construction Portal", title: "Portal-Home", icon: "fas fa-home", appKey: AppFeatureEnum.Portal }, true);
        });

        this.selectedMarket$ = this.orgSelectionService.selectedMarket
            .pipe(
                takeUntil(this.ngUnsubscribe$),
                tap(mkt => {
                    if (mkt.appFeatures.find(af => af.appFeatureId === AppFeatureEnum.Schedules)) {
                        this.enableSchedules = true;
                    } else {
                        this.enableSchedules = false;
                    }

                    if (mkt.appFeatures.find(af => af.appFeatureId === AppFeatureEnum.Recordables)) {
                        this.enableRecordables = true;
                    } else {
                        this.enableRecordables = false;
                    }

                    if (mkt.appFeatures.find(af => af.appFeatureId === AppFeatureEnum.PurchaseOrders)) {
                        this.enablePurchaseOrders = true;
                    } else {
                        this.enablePurchaseOrders = false;
                    }

                    if (mkt.appFeatures.find(af => af.appFeatureId === AppFeatureEnum.Service)) {
                        this.enableService = true;
                    } else {
                        this.enableService = false;
                    }

                    if (mkt.appFeatures.find(af => af.appFeatureId === AppFeatureEnum.BWP)) {
                        this.enableBWP = true;
                    } else {
                        this.enableBWP = false;
                    }

                    if (mkt.appFeatures.find(af => af.appFeatureId === AppFeatureEnum.BQA)) {
                        this.enableBQA = true;
                    } else {
                        this.enableBQA = false;
                    }

                    this.selectedMarket = mkt;
                })
            )

        this.selectedMarket$.subscribe();
    }
}